import { RouteEnum } from 'app/shared/enums';

export const getHomeRoute = (pathname: string) =>
  pathname.includes(RouteEnum.TRAVEL) ? RouteEnum.TRAVEL : RouteEnum.HOME;
